import { useState } from 'react';
import { Card, Input, Button, StatCard } from '@getpay93/ui';
import { useReferrals } from '../../data/hooks';

export function Referidos() {
  const ref = useReferrals();
  const [copied, setCopied] = useState(false);
  const r = ref.data;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <Card>
        <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.08em', color: 'var(--text-hint)' }}>Tu código de referido</div>
        <div style={{ fontSize: 30, fontWeight: 800, letterSpacing: '.12em', color: 'var(--brand-green)' }}>{r?.code ?? '—'}</div>
        <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>Comparte tu link. Por cada negocio que se activa ganas {r?.rewardSlots ?? 5} cupos gratis (hasta {r?.maxBonusSlots ?? 20}).</p>
        {r ? (
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <Input readOnly value={r.shareUrl} containerStyle={{ flex: 1 }} />
            <Button variant="outline" iconLeft="copy" onClick={() => { void navigator.clipboard?.writeText(r.shareUrl); setCopied(true); }}>{copied ? 'Copiado' : 'Copiar'}</Button>
          </div>
        ) : null}
      </Card>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16 }}>
        <StatCard label="Cupos ganados" value={r ? `${r.bonusSlots} / ${r.maxBonusSlots}` : '—'} tone="green" icon="gift" />
        <StatCard label="Referidos" value={String(r?.referredCount ?? 0)} tone="default" icon="users" />
        <StatCard label="Activados" value={String(r?.activatedCount ?? 0)} tone="green" icon="check-circle" />
      </div>
    </div>
  );
}
